import { BigNumber } from '../utils/bignumber';

export type PolicyRegistryEntryData = [string, string, string, BigNumber, BigNumber, BigNumber];

export class PolicyRegistryEntry {
    constructor(
        public carrier: string,
        public insured: string,
        public applicationHash: string,
        public coverageLimit: BigNumber,
        public premium: BigNumber,
        public issuanceBlockTimestamp: BigNumber
    ) {
        this.carrier = carrier;
        this.insured = insured;
        this.applicationHash = applicationHash;
        this.coverageLimit = coverageLimit;
        this.premium = premium;
        this.issuanceBlockTimestamp = issuanceBlockTimestamp;
    }
    
    static fromData(data: PolicyRegistryEntryData) {
        return new this(data[0], data[1], data[2], data[3], data[4], data[5]);
    }
}

